import React, { useRef } from 'react'
import { GoChevronDown } from 'react-icons/go'
import { FaPlus, FaMinus } from 'react-icons/fa'
import { FiExternalLink } from 'react-icons/fi'
import { Link, useNavigate } from 'react-router-dom'
import { BsSearch } from 'react-icons/bs'
import UserContext from '../../frontendTestContext/UserContext'
import { useContext } from 'react'
import { useState } from 'react'
import Footer from '../../components/footer/Footer'

const Search = (props) => {
  const searchRef = useRef(null)
  const navigate = useNavigate()
  const userContextUsed = useContext(UserContext)
    const shopData = userContextUsed.shop
    const [filter, setFilter] = useState("all")
    const sortedProducts = shopData.products.sort((a, b) => a.productDetailsFromBackend.productName.localeCompare(b.productDetailsFromBackend.productName));
    const searchedShop = sortedProducts.filter((product)=>{
        const searchTerm = props.search.toLowerCase()
        return product.productDetailsFromBackend.productName.toLowerCase().includes(searchTerm.toLowerCase())
    })
    const filteredShop = searchedShop.filter((product)=>{
        var userFinds = product
        if(filter === "all"){
            userFinds = product
        }
        else if(filter === "softwares"){
            userFinds = product.productDetailsFromBackend.productCategory === "software"
        }
        else if(filter === "media"){
            userFinds = product.productDetailsFromBackend.productCategory === "media"
        }
        else if(filter === "ebooks"){
            userFinds = product.productDetailsFromBackend.productCategory === "ebook"
        }
        return userFinds
    })
    const shopItems = filteredShop.map((product)=>{
        const cartStatus = product.productDetailsFromBrowser.hasBeenAddedToCart
        const detailsFromBackend = product.productDetailsFromBackend
        // const detailsFromBrowser = product.productDetailsFromBrowser
        return (
            <div className="product" key={detailsFromBackend.productId}>
                <div className="top" style={{
                    backgroundImage: `linear-gradient(#0000, #000e), url(${detailsFromBackend.productUrls.productImgUrl})`,
                }}>
                    <Link onClick={
                      ()=>{
                        props.handleLoader(true, true)
                      }
                    } to={`/product/${detailsFromBackend.productUrls.productUrl}`} className='product__link'>
                        <FiExternalLink />
                    </Link>
                    <div className="product-details">
                        <div className="product-name">
                            {detailsFromBackend.productName}
                        </div>
                        <div className="product-price">
                            ${detailsFromBackend.productPriceInDollar}
                        </div>
                    </div>
                </div>
                <div className={cartStatus ? "bottom in-cart" : "bottom"} onClick={()=>{
                    if (cartStatus){
                        props.removeFromCart(detailsFromBackend.productId)
                    }
                    else {
                        props.addToCart(detailsFromBackend.productId)
                    }
                }}>
                    {cartStatus ? <FaMinus />:
                    <FaPlus />}
                    <span>
                        {cartStatus ? "Remove from Cart": "Add to Cart"}
                    </span>
                </div>
            </div>
        )
    })
  return (
    <div className='shop'>
      <div className="content">
        <div className="heading">
          <h2>
            Search{props.search.length > 0 && <>: "{props.search}"</>}
          </h2>
          <div className="search-bar">
            <BsSearch className="search-icon"  onClick={()=>{
                searchRef.current.blur()
            }} />
            <input ref={searchRef} type="search" value={props.search} onChange={(e)=>{
                props.setSearch(e.target.value)
                if(props.search.length > 2){
                    navigate("/search")
                }
            }} placeholder="Search Here" />
          </div>
        </div>
        <div className="first-section">
          <div className="title">
            categories
          </div>
          <div className="current">
            {filter} <GoChevronDown />
            <div className="categories">
              <button onClick={()=>{
                setFilter("all")
              }}>
                All
              </button>
              <button onClick={()=>{
                setFilter("ebooks")
              }}>
                eBooks
              </button>
              <button onClick={()=>{
                setFilter("softwares")
              }}>
                Softwares
              </button>
              <button onClick={()=>{
                setFilter("media")
              }}>
                Media
              </button>
            </div>
          </div>
        </div>
        <div className="second-section container">
            {shopItems.length > 0 ? <div className="second-section container">
            {shopItems}
            </div> : <div className="second-section container">
                <div className="failed">
                    <h2>Didn't Find that Product</h2>
                    <p>
                    Try searching for another term or go back to <Link to={"/"}>home</Link>
                    </p>
                </div>
            </div>}
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default Search